import { CommonButton } from "./Buttons";
import { FiEdit } from "react-icons/fi";
import React from "react";


export const MasterButton = ({ resetForm, update, loading, disabled, label, icon, onClick, col1=8, col2, col3 }) => {
    return(
        <>
            <div className={`col-${col1}`}></div>
            <div className="flex col-4" style={{"padding": "0px"}}>
                <div className={`flex col-${col2}`}></div>
                <div className={`flex col-${col3}`}>
                    <div className="flex gap-2">
                        <CommonButton type="reset" onClick={resetForm} className=" p-button-raised p-button-danger" title="Reset" label="Reset" icon="pi pi-times" color="p-button-raised p-button-success" />
                        <CommonButton
                            type="submit"
                            className={`p-mr-2 p-button-raised ${update && !loading ? "p-button-warning" : !update && !loading && "p-button-success"}`}
                            title={update && !loading ? "Update" : !update && !loading ? "Save" : "Loading"}
                            disabled={disabled || loading}
                            label={update && !loading ? "Update" : !update && !loading ? "Save" : "Loading"}
                            icon={update && !loading ? <FiEdit className="text-3xl mr-2" /> : !update && !loading ? "pi pi-save" : "pi pi-spin"}
                            loading={loading}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

